import React from 'react';

import { makeBtStyles } from '../../Theme';


const useRouteLineStyles = makeBtStyles( theme => ({
  myLine: {
    animation: '$dash 1s ease-in-out forwards' // 1s is overridden in JS
  },
  '@keyframes dash': {
    'to': {
      strokeDashoffset: '0'
    }
  }
}));


export default function AnimatedLine({ from, to, zoom, strokeWidth, color, onAnimationEnd, markerRadius }) {
  const classes = useRouteLineStyles();

  const dx = Math.abs( to[0] - from[0] );
  const dy = Math.abs( to[1] - from[1] );
  const length = Math.sqrt( dx*dx + dy*dy );

  // Don't draw the line on top of the marker we just put down (so mouse hover works, z-index not supported :/ )
  const angle = Math.abs( Math.atan( (to[0]-from[0]) / (to[1]-from[1]) ) );
  const clipX = markerRadius * Math.sin(angle);
  const clipY = markerRadius * Math.cos(angle);

  const fromX = from[0] + ( to[0] > from[0] ? 1 : -1 ) * clipX;
  const fromY = from[1] + ( to[1] > from[1] ? 1 : -1 ) * clipY;

  return (
    <path
      d={`M${fromX},${fromY}L${to[0]},${to[1]}`}
      strokeWidth={strokeWidth}
      stroke={color}
      className={classes.myLine}
      onAnimationEnd={onAnimationEnd}
      style={{
        strokeDasharray: length,
        strokeDashoffset: length,
        animationDuration: `${length*zoom*3}ms`
      }}
    />
  );
}
